import ApiConnector from '@/models/ApiConnector';
import ServiceModel from '@models/ServiceModel';

const services = window.APP_CONFIG?.services || [];
const service = services.find(service => service.id === 'notification');

export const mapConnector = new ApiConnector({ baseURL: service?.configurations.api_endpoint });

export default class NotificationServiceModel extends ServiceModel {
	public static get connector() {
		return mapConnector;
	}

	public static serviceName = 'notification';
	public static partitionName = '$';
}
